import { AxiosInstance } from 'axios';
import { axiosFactory } from '../../../client';
import * as ROUTES from './routes';
import { CandidateAnnouncementsResponse } from '../models';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api`;
const timeout = 5000;

export const candidateAnnouncementClient = axiosFactory(baseURL, timeout);

export const candidateTestAnnouncementClient = (candidateAnnouncementClient as unknown) as AxiosInstance;

/** get candidate announcements
 * */
export const getCandidateAnnouncements = () =>
  candidateAnnouncementClient.get<CandidateAnnouncementsResponse[]>(
    `${ROUTES.CANDIDATE_LOGIN_ANNOUNCEMENTS}`
  );
